export default {
    AUTH: 'auth',
    LOGOUT: 'logout',
    SET_TEAM: 'setTeam',
    UPDATE_BALANCE: 'updateBalance',
    UPDATE_STATE: 'updateState',
}